export default class HSLcontrol {
	constructor() {
		this.defaultValues = {
			hue: 0,
			saturation: 1,
			luminance: 1,
			lum_sat: 1,
			sat_sat: 1,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length, controlSelected = "hue_hue") {
		UI.createAdjustmentBlockTemplate("hsl", blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".control-selector__items-container > span")
			.on("click", (e, animate) => this.controlSelection(e.currentTarget, animate));
		$(element)
			.find(".control-color-selector > span")
			.on("click", (e, animate) => this.controlColorSelection(e.currentTarget, animate));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(`.control-selector__items-container > span[data-control="hue"]`)
			.trigger("click", [false]);
		$(element)
			.find(`.control-color-selector > span[data-color="reds"]`)
			.trigger("click", [false]);

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		$(element)
			.find(".range_slider:not(.opacity_slider)")
			.on("input", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		$(element)
			.find(".range_value:not(.opacity-input)")
			.on("change", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		$(element)
			.find(".control-selector__label-container")
			.on("click", e => {
				e.stopPropagation();
				this.toggleControlSelector($(e.currentTarget));
			});

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "HSL",
			passes: this.addHSLPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				hue: {
					Reds: 0,
					Yellows: 0,
					Greens: 0,
					Cyans: 0,
					Blues: 0,
					Magentas: 0,
				},
				saturation: {
					Reds: 1,
					Yellows: 1,
					Greens: 1,
					Cyans: 1,
					Blues: 1,
					Magentas: 1,
				},
				luminance: {
					Reds: 1,
					Yellows: 1,
					Greens: 1,
					Cyans: 1,
					Blues: 1,
					Magentas: 1,
				},
				lum_sat: {
					Blacks: 1,
					Shadows: 1,
					Midtones: 1,
					Highlights: 1,
					Whites: 1,
				},
				sat_sat: {
					"10": 1,
					"20": 1,
					"30": 1,
					"40": 1,
					"50": 1,
				},
			},
		});
	}

	addHSLPasses() {
		const pass1 = gpu.createHueSaturationShaderPass();
		const pass2 = gpu.createLuminanceSaturationPass();
		const pass3 = gpu.createSaturationSaturationPass();

		gpu.addPassToComposer(pass1, "toMiddle");
		gpu.addPassToComposer(pass2, "toMiddle");
		gpu.addPassToComposer(pass3, "toMiddle");

		return [pass1, pass2, pass3];
	}

	toggleControlSelector($el) {
		let itemsContainer = $el.siblings(".control-selector__items-container");
		if (itemsContainer.is(":visible")) itemsContainer.hide();
		else itemsContainer.show();
	}

	controlSelection(selectedControl, animate = true) {
		let $blockOptions = $(selectedControl).closest(".block_options");
		$blockOptions.find(".control-selector__items-container").hide();
		$blockOptions.find(".selected-control-name").html($(selectedControl).html());
		if (animate) {
			$blockOptions.find(".block-controls-container").fadeOut(2);
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).fadeIn();
		} else {
			$blockOptions.find(`.block-controls-container[data-control="${selectedControl.dataset.control}"]`).show();
		}
	}

	controlColorSelection(selectedColorControl, animate = true) {
		let $controlsContainer = $(selectedColorControl).closest(".block-controls-container");
		$controlsContainer.find(".control-color-selector > span").removeClass("selected");
		$(selectedColorControl).addClass("selected");
		if (animate) {
			$controlsContainer.find(".block-sub-controls-container").fadeOut(2);
			$controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).fadeIn();
		} else {
			$controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).show();
		}
	}

	sliderHandler($element) {
		let value = parseFloat($element.val());
		let color = $element.data("range");
		let subControl = $element.closest(".block-sliders-container").data("sub-control");

		if ($element.hasClass("range_value")) {
			if (value > parseInt($element.attr("max"))) {
				value = parseInt($element.attr("max"));
				$element.val(value);
			}
			if (value < parseInt($element.attr("min"))) {
				value = parseInt($element.attr("min"));
				$element.val(value);
			}
		}

		if ($element.hasClass("range_slider"))
			$element
				.closest(".block-sliders-container")
				.find(".range_value")
				.val(value);
		else
			$element
				.closest(".block-sliders-container")
				.find(".range_slider")
				.val(value);

		// lutify.getActiveBlock().color = value;
		lutify.getActiveBlock().values[subControl][color] = value;

		if (subControl == "hue") this.callGPUHue(value / 180.0, color);
		else if (subControl == "saturation") this.callGPUSaturation(value - 1 > 0 ? (value - 1) * 0.6 : value - 1, color);
		else if (subControl == "luminance") this.callGPULuminance(value - 1, color);
		else if (subControl == "lum_sat") this.callGPULumSat(value - 1 > 0 ? (value - 1) * 0.6 : value - 1, color);
		else if (subControl == "sat_sat") this.callGPUSatSat(value - 1 > 0 ? (value - 1) * 0.6 : value - 1, color);
	}

	callGPUHue(value, color) {
		lutify.getActiveBlock().passes[0].enabled = true;
		lutify.getActiveBlock().passes[0].uniforms["hue" + color].value = value;
		gpu.render();
	}

	callGPUSaturation(value, color) {
		lutify.getActiveBlock().passes[0].enabled = true;
		lutify.getActiveBlock().passes[0].uniforms["sat" + color].value = value;
		gpu.render();
	}

	callGPULuminance(value, color) {
		lutify.getActiveBlock().passes[0].enabled = true;
		lutify.getActiveBlock().passes[0].uniforms["lum" + color].value = value;
		gpu.render();
	}

	callGPULumSat(value, color) {
		lutify.getActiveBlock().passes[1].uniforms["sat" + color].value = value;
		lutify.getActiveBlock().passes[1].enabled = true;
		gpu.render();
	}

	callGPUSatSat(value, color) {
		lutify.getActiveBlock().passes[2].uniforms["sat" + color].value = value;
		lutify.getActiveBlock().passes[2].enabled = true;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		Object.keys(values).forEach(valuesGroup => {
			Object.keys(values[valuesGroup]).forEach(value => {
				let slider = $block.find(`.block-sliders-container[data-sub-control="${valuesGroup}"] > .range_slider[data-range="${value}"]`);
				slider.val(values[valuesGroup][value]);
				slider.trigger("input");
			});
		});

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
